import { useEffect, useRef } from 'react';
export const useResizeObserver = onResize => {
  const observer = useRef(null);
  useEffect(() => {
    observer.current = new ResizeObserver(onResize);
  }, [onResize]);
  return observer.current;
};